import { useState, useEffect } from "react";
import {
  IconShieldCheck,
  IconCircleCheck,
  IconCircleDashed,
} from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import useCountUp, { COUNT_FORMATTERS } from "../../../../hooks/useCountup";
import { checklistConfig } from "./data";



export default function ProfileStrengthCard({ data }) {
  const [filled, setFilled] = useState(false);

  const isCompleted = (value) => value === "Yes" || value === true;

  const strengthChecklist = checklistConfig.map(([label, key]) => ({
    label,
    done: isCompleted(data?.[key]),
  }));

  const completed =
    strengthChecklist?.filter((item) => item?.done)?.length || 0;
  const total = strengthChecklist?.length || 0;
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100);
  const pctLabel = useCountUp(percent, 1300, COUNT_FORMATTERS.percent, "mount");

  useEffect(() => {
    const t = setTimeout(() => setFilled(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={styles.strengthCard}>
      <div className={styles.strengthTop}>
        <span className={styles.strengthTitle}>
          <IconShieldCheck size={17} /> Profile Strength
        </span>
        <span className={styles.strengthPct}>{pctLabel} Complete</span>
      </div>
      <div className={styles.strengthBar}>
        <div
          className={styles.strengthFill}
          style={{ width: filled ? `${percent}%` : "0%" }}
        />
      </div>
      <div className={styles.strengthList}>
        {strengthChecklist?.map((item) => (
          <span
            key={item?.label}
            className={`${styles?.strengthItem} ${item?.done ? styles?.strengthItemDone : ""}`}
          >
            {item?.done ? (
              <IconCircleCheck size={16} />
            ) : (
              <IconCircleDashed size={16} />
            )}
            {item?.label}
          </span>
        ))}
      </div>
    </div>
  );
}
